import React from 'react';
interface HeadingAccentProps {
  children: React.ReactNode;
  className?: string;
}
export function HeadingAccent({
  children,
  className = ''
}: HeadingAccentProps) {
  return <span className={`relative inline-block ${className}`} data-id="element-1161">
      <span className="relative z-10 text-[#7A9E7E]" data-id="element-1162">{children}</span>
      <span className="absolute -bottom-2 left-0 right-0 h-3 bg-sage/20 -z-0 rounded-sm" data-id="element-1163" />
    </span>;
}